module.exports = __webpack_public_path__ + "static/img/2.75db392.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/eng/2.png
// module id = jBhk
// module chunks = 0